<div *ngIf="reportGenerationForm != null" [formGroup]="reportGenerationForm">
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        label="Show only employees who have been paid in the last 12 months."
        formControlName="limitEmployees"
        id="limitEmployees"></lib-checkbox>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-4">
      <label
        >Employee Name
        <small class="form-text d-inline"
          >(You can only select up to 15 employees when running this report)</small
        ></label
      >
      <lib-multiselect
        defaultButtonText="Select 1-15 Employees"
        [options]="peopleObs | async"
        formControlName="employeeIds"
        [maxSelections]="15"></lib-multiselect>
    </div>
    <div class="col-12 col-md-4">
      <label>Timeframe</label>
      <lib-date-range-picker formControlName="dateRange"></lib-date-range-picker>
    </div>
  </div>
  <div
    class="row"
    *ngIf="reportGenerationForm.errors?.['invalidDateRange'] && reportGenerationForm.touched">
    <div class="col-12">
      <p class="error-text">Begin date should be before End date</p>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        formControlName="reportPeriodTotals"
        id="reportPeriodTotals"
        label="Report Period Totals"></lib-checkbox>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        formControlName="includePickupOrSuccessorFigures"
        id="includePickupSuccessorFigures"
        label="Include Pickup/Successor Figures"></lib-checkbox>
    </div>
  </div>
</div>
<lib-report-buttons
  *ngIf="reportGenerationForm != null"
  [disabled]="reportGenerationForm.invalid"
  (generateReport)="generateReport()"
  (downloadReport)="downloadReport($event)"></lib-report-buttons>
